export default "__VITE_ASSET__273b6fc0__"